import React from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { TECH_TABS } from "@/lib/content";

export default function TechnicalDetails() {
  return (
    <section
      id="technik"
      data-testid="tech-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-[#0055A4] mb-6">
              Technische Details
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
              Transparenz auf jeder Ebene.
            </h2>
            <p className="mt-6 text-slate-600 text-base leading-relaxed">
              Wir glauben an klare Spezifikationen. Hier finden Sie die
              wichtigsten technischen Eckdaten unserer Lösungen –
              projektabhängig erweiterbar und auf Anfrage detailliert
              dokumentiert.
            </p>
            <a
              href="#kontakt"
              data-testid="tech-cta-spec"
              className="mt-8 inline-flex items-center gap-2 text-[#0055A4] font-medium hover:gap-3 transition-all"
            >
              Detaillierte Spezifikation anfragen →
            </a>
          </div>

          <div className="lg:col-span-8">
            <Tabs defaultValue="mast" className="w-full">
              <TabsList
                data-testid="tech-tabs-list"
                className="grid grid-cols-5 h-auto bg-slate-100 p-1 rounded-lg gap-1 w-full"
              >
                {TECH_TABS.map((t) => (
                  <TabsTrigger
                    key={t.value}
                    value={t.value}
                    data-testid={`tech-tab-${t.value}`}
                    className="data-[state=active]:bg-white data-[state=active]:text-[#0055A4] data-[state=active]:shadow-sm text-slate-600 text-xs lg:text-sm px-2 py-2 rounded-md whitespace-normal leading-tight text-center"
                  >
                    {t.label}
                  </TabsTrigger>
                ))}
              </TabsList>

              {TECH_TABS.map((t) => (
                <TabsContent
                  key={t.value}
                  value={t.value}
                  data-testid={`tech-content-${t.value}`}
                  className="mt-6"
                >
                  <div className="border border-slate-200 rounded-xl overflow-hidden">
                    <table className="w-full text-sm">
                      <tbody className="divide-y divide-slate-200">
                        {t.rows.map(([k, v]) => (
                          <tr key={k} className="hover:bg-slate-50">
                            <th
                              scope="row"
                              className="text-left font-mono-tech text-xs uppercase tracking-widest text-slate-500 px-6 py-4 w-1/3 align-top"
                            >
                              {k}
                            </th>
                            <td className="px-6 py-4 text-slate-800 font-medium">
                              {v}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </TabsContent>
              ))}
            </Tabs>
          </div>
        </div>
      </div>
    </section>
  );
}
